<template>
    <div class="container" style="margin:0%; padding: 0%;">
       <div class="row">
            <div class="col-md-12">
                <div class="content">
                    <h2>Dashboard</h2>
                </div>
            </div>
        </div>
        <div class="row" v-if="app_role == 0">
            <div class="card-row">
                <div class="card bg-success">
                   <span> <i class="fa fa-users"></i> &nbsp;&nbsp;<h3>Registered Users</h3></span> 

                   <span class="count">
                        {{ count }}
                   </span>
                </div>
                <div class="card bg-primary">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>Paid Users</h3></span> 

                    <span class="count">
                        {{ paid }}
                   </span>
                </div>
                <div class="card bg-info">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>Subscribers</h3></span> 

                    <span class="count_mode">
                        LetsPlay / Hangout: {{ letsplay }} <br>
                        Lets Marry: {{ marry }} <br>
                    </span>

                </div>
                <div class="card bg-secondary">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>Total Amount</h3></span> 

                    <span class="count">
                       {{amount }}
                   </span>

                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="card-row">
                <div class="card bg-info">
                   <span> <i class="fa fa-users"></i> &nbsp;&nbsp;<h3>Referrals</h3></span> 

                   <span class="count">
                        {{ referral_count }}
                   </span>
                </div>
                <div class="card bg-primary">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>Paid Referrals</h3></span> 

                    <span class="count">
                        {{ referral_paid }}
                   </span>
                </div>
                <div class="card bg-success">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>App Category</h3></span> 

                    <span class="count_mode">
                        LetsPlay / Hangout: {{ referral_letsplay }} <br>
                        Lets Marry: {{ referral_marry }} <br>
                    </span>

                </div>
                <div class="card bg-secondary">
                    <span> <i class="fa fa-user"></i> &nbsp;&nbsp;<h3>Amount Earned</h3></span> 

                    <span class="count">
                       {{referral_amount }}
                   </span>

                </div>
            </div>

            <!-- <div class="card-row">
                <div class="card" style="overflow-y:auto; height: 300px">
                    <table class="table table-bordered table-responsive">
                        <thead>
                            <th>
                                Message alert!
                            </th>
                                                       
                        </thead>
        
                        <tbody>
                            <tr v-for="(data, index) in users" :key="index">
                                <td>
                                    
                                </td>             
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>    -->
        </div>
        <div class="row" v-if="app_role==0">
            <div class="card-row">
                <div class="card" style="overflow-y:auto; height: 300px">
                    <table class="table table-bordered table-responsive">
                        <thead>
                            <th>
                                Fullname
                            </th>
                            <th>
                                Sex
                            </th>
                            <th>
                                Email
                            </th>
                            <th>
                                Phone
                            </th>
                            <th>
                                Location
                            </th>
                            <th>
                                Occupation
                            </th>
                            <th>
                                Religion
                            </th>
                            <th>
                                User Type
                            </th>
                            <th>
                                Paid Status
                            </th>
                            <th>
                                Date Registered
                            </th>
                            <th>
                                Action
                            </th>
                        </thead>
        
                        <tbody>
                            <tr v-for="(data, index) in users" :key="index">
                                <td>
                                    {{ data.firstname }} {{ data.lastname }}
                                </td>
                                <td>
                                    {{ data.gender }}
                                </td>
                                <td>
                                    {{ data.email }}
                                </td>
                                <td>
                                    {{ data.phone }}
                                </td>
                                <td>
                                    {{ data.location }}
                                </td>
                                <td>
                                    {{ data.occupation }}
                                </td>
                                <td>
                                    {{ data.religion }}
                                </td>
                                <td>
                                    <span v-if="data.type_status == 2"> Lets Marry</span>
                                    <span v-else-if="data.type_status == 1"> Lets Play/ Date & Hangout</span>

                                </td>
                                <td>
                                    <span v-if="data.paid_status == 1" style="color:green"> Paid</span>
                                    <span v-else-if="data.paid_status == 0" style="color:red"> Not Paid</span>
                                </td>
                                <td>
                                    {{ data.created_at }}
                                </td>
                                <td>
                                    Activate/Deactivate
                                </td>
                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>           
        </div>
    </div>    
    </template>
    <script>
    //import swal from 'sweetalert2';
    export default {
        
    data() {
    return {
        users: [],
        count: 0,
        paid: 0,
        marry: 0,
        letsplay: 0,
        app_role: '',
        amount: 0,
        referrals: [],
        referral_count: 0,
        referral_paid: 0,
        referral_marry: 0,
        referral_letsplay: 0,
        referral_amount: 0,
    };
    },
    
    beforeMount(){
        this.listUsers();  
        this.listReferral(); 
    },
    mounted() {
        this.app_role = localStorage.getItem("app_status");
    },
    created(){
        //this.listMyProfile();   
    },
    
    
      methods: {
        showSidebar() {
            var x = document.getElementById("sidebar");
            if (x.style.display === "none") {
                x.style.display = "block";
                document.getElementById('btn').style.display='none'
                document.getElementById('logo').style.display='block'
            } else {
                x.style.display = "none";
                document.getElementById('btn').style.display='block'
                document.getElementById('logo').style.display='none'
            }
        },
       
        profile() {
            document.getElementById("profile").classList.add('profile-menu');
        },
        
        async listUsers(){
             try{
    
                const response = await this.$http.get('/fetchAll-users', )
                //console.log(response.data.data)
                this.users = response.data.data;
                this.count = response.data.count;
                this.paid = response.data.paid;
                this.marry = response.data.letsmarry;
                this.letsplay = response.data.letsplay;
                this.amount = response.data.amount;
                          
                }catch (err) {
                console.log(err);
            }
        },

        async listReferral(){
             try{
    
                const response = await this.$http.get('/fetchAll-referral', )
                //console.log(response.data.data)
                this.referrals = response.data.data;
                this.referral_count = response.data.count;
                this.referral_paid = response.data.paid;
                this.referral_marry = response.data.letsmarry;
                this.referral_letsplay = response.data.letsplay;
                this.referral_amount = response.data.amount;
                          
                }catch (err) {
                console.log(err);
            }
        },
       
      },
        
    }
    </script>
    <style lang="scss" scoped>

    .card-row{
        display:flex;
        flex-direction: row;
        justify-content:space-evenly;
    }
    .card{
        margin: 6px;
        width: 100%;
        height: auto;
        padding: 4px;
        border: 1px solid #D33E74;

        h3 {
            margin-top: 4px;
            font-size: 14px;
            font-weight: 500;
            color:rgb(27, 27, 27);
        }

        span{
            display: flex;
            flex-direction: row;
            .fa-users{
                font-size: 20px;
            }
            .fa-user{
                font-size: 20px;
            }
        }
        .count{
            display: flex;
            flex-direction: row;
            justify-content: center;
            font-size: 20px;
            font-weight: 600;
        }
        .count_mode{
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 12px;
            font-weight: 400;
            padding-left: 30px;
        }
    }
    h2 {
        color: #FFF;
        font-size:18px;
    }
    table > thead {
        font-size: 12px;
    }
    table > tbody {
        font-size: 11px;
    }

    @media screen and (max-width: 700px) {
        .card-row{
            display:flex;
            flex-direction: column;
            justify-content:space-evenly;
        }
        .card{
            margin: 6px;
            width: 95%;
            height: 120px;
            padding: 4px;
            border: 1px solid #D33E74;
    
            h3 {
                margin-top: 4px;
                font-size: 16px;
                font-weight: 300;
                color:rgb(27, 27, 27);
            }
    
            span{
                display: flex;
                flex-direction: row;
                .fa-users{
                    font-size: 20px;
                }
                .fa-user{
                    font-size: 20px;
                }
            }
            .count{
                display: flex;
                flex-direction: row;
                justify-content: center;
                font-size: 20px;
                font-weight: 500;
            }
            .count_mode{
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 13px;
                font-weight: 200;
                padding-left: 30px;
            }
        }
        h2 {
            color: #FFF;
            font-size: 20px;
        }

    }

    </style>